import React from "react";

export default function AssessmentCriteria() {
  return (
    <div className="space-y-8">
      <section className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Assessment &amp; Evaluation Criteria</h1>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          Assessment across all instruments and levels is guided by clear principles and detailed marking criteria. These ensure that candidates are evaluated consistently, regardless of where or how they take their examination.
        </p>
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur-xl sm:grid-cols-2 sm:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Evaluation principles</h2>
          <ul className="space-y-1">
            <li>• Candidates are assessed against level-specific descriptors rather than in comparison with each other.</li>
            <li>• Examiners consider both technical control and musical communication in every performance.</li>
            <li>• Marking reflects the overall consistency and reliability of the performance across all components.</li>
          </ul>
        </div>
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Grading structure</h2>
          <p>
            Each examination results in a grade that reflects the candidate&apos;s overall achievement. Descriptors for each grade band indicate typical features of performances within that range, supporting clear expectations and constructive feedback.
          </p>
        </div>
      </section>
    </div>
  );
}
